import { authService } from '../service/auth/auth-service'
import { errorUtil } from '../util/auth-error-util'
import { queryKeys } from '../util/query-keys'
import { toasterUtil } from '../util/toaster-util'
import { useMutation } from '@tanstack/react-query'

type ResendPasswordlessCodeInput = {
  email: string
}

export const useResendPasswordlessCode = (options?: {
  onError?: (error: Error) => void
  onSuccess?: () => void
}): {
  resendPasswordlessCode: (input: ResendPasswordlessCodeInput) => void
  isLoading: boolean
  error: Error | null
} => {
  const {
    mutate: resendPasswordlessCodeMutation,
    isLoading,
    error,
  } = useMutation<{ expireDate: number }, Error, ResendPasswordlessCodeInput>(
    async (input) => {
      return authService.resendPasswordlessCode({ email: input.email })
    },
    {
      mutationKey: queryKeys.resendPasswordlessCode(),
      onSuccess: () => {
        toasterUtil.success('A new code has been sent to your email.')
        options?.onSuccess?.()
      },
      onError: (err) => {
        errorUtil.logError(err)
        toasterUtil.error(err.message ?? 'Failed to resend code. Please try again.')
        options?.onError?.(err)
      },
    },
  )

  const resendPasswordlessCode = (input: ResendPasswordlessCodeInput): void => {
    resendPasswordlessCodeMutation(input)
  }

  return {
    resendPasswordlessCode,
    isLoading,
    error,
  }
}
